<template>
  <v-navigation-drawer
    :class="color"
    dark
    app
    v-model="drawer"
    overflow
  >
    <v-list>
      <template v-for="item in nitems"> 
        <v-list-group
          v-if="item.child"
          :key='item.title'
          :value="false"
          :prepend-icon="item.icon"
        >
          <template v-slot:activator>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </template>
          <v-list-item  v-for="itemChild in item.child" :to="itemChild.route" :key="itemChild.title">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
            <span v-html="itemChild.title.replace(/\\n/g, '<br>')"></span>
          </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item
          v-else
          :key="item.title"
          :to='item.route'
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <span v-html="item.title.replace(/\\n/g, '<br>')"></span>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  computed: {
    drawer: {
      get: function() {
        return this.$store.getters.drawer
      },
      set: function(na) {
        return na
      }
    },
    color: function() {
      return this.$store.getters.drawerColor
    },
    nitems: function() {
      return this.$store.getters.drawerContent
    }
  }
}
</script>

<style>

</style>